<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="实验室名称："
        prop="labName">
        <el-input v-model="info.labName"></el-input>
      </el-form-item>
      <el-form-item
        label="联系人："
        prop="contactPerson">
        <el-input v-model="info.contactPerson"></el-input>
      </el-form-item>
      <el-form-item
        label="联系电话："
        prop="contactPhone">
        <el-input v-model="info.contactPhone"></el-input>
      </el-form-item>
      <el-form-item
        label="邮箱："
        prop="contactEmail">
        <el-input v-model="info.contactEmail"></el-input>
      </el-form-item>
      <el-form-item
        label="地址："
        prop="address">
        <el-input v-model="info.address"></el-input>
      </el-form-item>
      <!-- <el-form-item
        label="检测资质："
        prop="testQualification">
        <el-input
          v-model="info.testQualification"
          type="textarea"
          :rows="4"
          :autosize="{ minRows: 2, maxRows: 4}"></el-input>
      </el-form-item> -->
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'EditLabModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        labId: null,
        labName: '',
        contactPerson: '',
        contactPhone: '',
        contactEmail: '',
        address: '',
        testQualification: ''
      },
      rules: {

        labName: [
          { required: true, message: '请输入实验室名称', trigger: 'blur' },
          { max: 30, message: '实验室长度最多 30 个字符', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { max: 15, message: '联系人长度最多 15 个字符', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /^1[0-9][0-9]\d{8}$/,
            message: '请输入正确的联系电话',
            trigger: 'blur'
          }
        ],
        contactEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入实验室地址', trigger: 'blur' },
          { max: 50, message: '实验室地址长度最多 50 个字符', trigger: 'blur' }
        ],
        testQualification: [
          { required: true, message: '请输入实验室资质', trigger: 'blur' },
          { max: 100, message: '长度最多 100 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const labId = this.info.labId
      return (labId ? '编辑' : '新增') + '实验室'
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        labId: null,
        labName: '',
        contactPerson: '',
        contactPhone: '',
        contactEmail: '',
        address: '',
        testQualification: ''
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.labId
            ? 'updatelab'
            : 'addlab'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add() {
      // this.info.parentSgsId = parentSgsId
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
